import { ActionType } from "../types";
import { Environments, EnvironmentsAction } from "../types/environments";

export const environments = (
  state: Environments = {},
  action: EnvironmentsAction
): Environments => {
  switch (action.type) {
    case ActionType.GET_ENVIRONMENTS_REQUEST:
      return {
        ...state,
        [action.key]: null,
      };
    case ActionType.GET_ENVIRONMENTS_SUCCESS:
      return {
        ...state,
        [action.key]: action.environments,
      };
    case ActionType.GET_ENVIRONMENTS_FAILURE:
      return {
        ...state,
        [action.key]: null,
      };
    default:
      return state;
  }
};
